// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lender-block a[data-v-5dd5c326]{display:inline-block}.lender-block a.lender-block__name[data-v-5dd5c326]{margin-top:.5rem}.lender-block .lender-block__angel-badge[data-v-5dd5c326]{transform:translateY(-.3125rem)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
